import {
    COUNTRIES_LIST,
    REGIONS_COLLECTION,
    SETTLEMENT_COLLECTION,
} from '@app/pages/clinic/models/country-related.data';

import { Address } from '@app/models/chip.model';

export function fullAddressString(addressData: Address): string {
    const countryName =
        COUNTRIES_LIST.find((item) => addressData.countryId && item.id === +addressData.countryId)
            ?.name || '';
    const regionName =
        REGIONS_COLLECTION.find((item) => addressData.regionId && item.id === +addressData.regionId)
            ?.name || '';
    const settlementName =
        SETTLEMENT_COLLECTION.find(
            (item) => addressData.settlementId && item.id === +addressData.settlementId,
        )?.name || '';
    return `${countryName}, ${regionName}, ${settlementName}, ${addressData.zipCode}, ${addressData.address}`;
}

export function countryNameById(countryId: string | number | null): string {
    return COUNTRIES_LIST.find((item) => countryId && item.id === +countryId)?.name || '';
}

export function regionNameById(regionId: string | number | null): string {
    return REGIONS_COLLECTION.find((item) => regionId && item.id === +regionId)?.name || '';
}

export function settlementNameById(settlementId: string | number | null): string {
    return (
        SETTLEMENT_COLLECTION.find((item) => settlementId && item.id === +settlementId)?.name || ''
    );
}
